let html = `<div class="empty empty--list">
    <div class="empty__title">#{empty_title}</div>
    <div class="empty__descr">#{empty_text}</div>
</div>`

export default html